import { render, staticRenderFns } from "./PageGroup.vue?vue&type=template&id=e6d1fbb8&scoped=true"
import script from "./PageGroup.vue?vue&type=script&lang=js"
export * from "./PageGroup.vue?vue&type=script&lang=js"
import style0 from "./PageGroup.vue?vue&type=style&index=0&id=e6d1fbb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d1fbb8",
  null
  
)

export default component.exports